var _defs, _path, _rect, _rect2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _rect3, _text, _rect4, _rect5, _rect6, _text2, _rect7, _rect8, _rect9, _text3, _rect0, _rect1, _rect10, _text4, _rect11, _rect12, _rect13, _text5, _rect14, _rect15, _rect16, _text6, _rect17, _text7, _rect18, _text8, _rect19, _text9, _rect20, _text0, _switch;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDisclosureTimeline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "937px",
    height: "198px",
    viewBox: "-0.5 -0.5 937 198",
    content: "<mxfile host=\"app.diagrams.net\" modified=\"2021-11-15T18:24:25.913Z\" agent=\"5.0 (Macintosh; Intel Mac OS X 10_15_7) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/95.0.4638.69 Safari/537.36\" etag=\"14fC242XL2mrOYhrbyWa\" version=\"15.7.3\" type=\"device\"><diagram name=\"Page-1\" id=\"fbcf5db9-b524-4cd4-e4f3-379dc89c3999\">7Zttc6o4GIZ/jR9lSMLrR1/oWWds62jn9OzHFCKyReNiPOr++g0aEAxtM7NqWRRnWvLwfl+5kzxBW6g33/5I8HL2SAMSt6AebFuo34IQAFfn/9LITkRc8xAIkygQoWNgEv1DRFAcF66jgKxKOzJKYxYty0GfLhbEZ6UYThK6Ke82pXH5qkscEikw8XEsR1+jgM0OUcfUj/E/SBTOsisDXWx5w/57mND1QlxvQRfksGWOs9OIXVczHNBNIYS8FuollLLD2nzbI3Eqa6bY4biHD7bmt5yQBVM5AGJ96qI307cRmTrEbosz/MbxWsggbpTtMl3iiD8O6q5YQt9zZUweCaKEc4jogpdXdJ3GuzM2j3kR8NVpFMc9GtOEl/eS8BBdMAEeIFHOdmlBpO8XHsdxFKZn9fljkSS/eGFX1E0/fEtCGRb30HbTY2VJsmckCSPbQkhI9IPQOWHJju8itkIoaq6oyW1gicDmWDGyajsr1AnHEEEs6mKYn/sIha8ILoqM4NeM9rWPBEL5zSxiZLLEfrp1w91aBlMWU6Ap4z3lxxWfmunna4iHpQpimOAg4oV+od4QvOLadVM2EbdiRxzDaHrPuVvAebi2IbI029KPCyxxBqalObCCNNJMJNM+B+y/9fDP7cPU+tUfj3buvOfp87GKKflZeLtIvoaNV8tDYzmNtmkFUaFvVtDXcWCQHIOkeQWZTzBkLafQPVeyIDqqsBe6lOAKDvtfC27a9dIbNVtvA9ZLbqPZciMd1Etvs356m/6bY/pnqt52zZpvq9l6W6hmejtf612ZNMA6Jg3A0c+DiZ/J1IxyTwtcu2pEqWtZblwaT0INOBdC5t6RVSHjkp8Qg7ZsruvjypLLO68SL56fmbCQvpX7/dqYDSjkEzdIDwGT46uh26CtMIAIQjIRRZqwGQ3pAsfeMdo9zsGkeh33GdJ0MmMP7y/C2E6gwmtGy2gP10wv9LnA/L7oOvHJZzVQZFgMJyFhnz06qkaWkJhXgN/lOzm/URQSwRs0iuEYp0apT9umkEzeIDLLMPI5wlq1bUBOjsZezxv89PoSN/74TGGquAKTJP/phO48CoL4o/Sr3HKeY1wHgaG5btlBFqhykHXNxAkodDQ3M5X/3wi7SLPtD4eCCMjeu/40vpwnj72fA++Vx3rPj6Oh99JoE9rwhIn8Eu267lNIgu/uU0FrahC6hUWlob26/aCcQ0+8pxceeXnmf4ad1IcPg/Fjcy3IxxuGW2gkT993WhwkkkjZFZQQumD6pfC+8+5LJd6WkQOtU0+YAS0Q7o87D6kXmz8YhY5Vr34QKmTdd7+poDV4s3jit7p8hwTKefqo83Lo/zqj0b7rGzbZdoZha+WvcX0wMLErMvLLeU/h3fDde0pjUJ4BZpW8Vn2dPOEyHPS8p4nHg8+jl8HzU3NNZwFTk1Lx7+7u5DSc36H+yGv6rLkk2sAoDztygb+Ng5x+p8VXQt5XDeZwMj74dgxITotRZocGcwDZ9/hrw0HOeuENcEC2NGS+IApePP64Yr+t8OMV5P0L</diagram></mxfile>",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 47 98 L 887 98",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 5,
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.24,
    y: -0.18,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.24,
    y: -0.18,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 98,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 195,
    cy: 98,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 294,
    cy: 98,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 553,
    cy: 98,
    rx: 15,
    ry: 15,
    fill: "#f0ad4e",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 722,
    cy: 98,
    rx: 15,
    ry: 15,
    fill: "#5cb85c",
    stroke: "none",
    pointerEvents: "all"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 882,
    cy: 98,
    rx: 15,
    ry: 15,
    fill: "#5cb85c",
    stroke: "none",
    pointerEvents: "all"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 30.91 61.91 L 73.1 61.91",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(-90,52,61.91)",
    pointerEvents: "all"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 173.91 134.09 L 216.1 134.09",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(-90,195,134.09)",
    pointerEvents: "all"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 272.9 61.91 L 315.09 61.91",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(-90,293.99,61.91)",
    pointerEvents: "all"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 531.9 134.09 L 574.09 134.09",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(-90,552.99,134.09)",
    pointerEvents: "all"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 722 40.82 L 722 20.8 L 721.97 33.45",
    fill: "none",
    stroke: "rgba(0, 0, 0, 1)",
    strokeMiterlimit: 10,
    pointerEvents: "stroke"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M 721.96 38.7 L 718.48 31.69 L 721.97 33.45 L 725.48 31.71 Z",
    fill: "rgba(0, 0, 0, 1)",
    stroke: "rgba(0, 0, 0, 1)",
    strokeMiterlimit: 10,
    pointerEvents: "all"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M 700.9 61.91 L 743.09 61.91",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(-90,721.99,61.91)",
    pointerEvents: "all"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M 860.91 134.09 L 903.1 134.09",
    fill: "none",
    stroke: "#3b3b3b",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    transform: "rotate(-90,882,134.09)",
    pointerEvents: "all"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 22.01,
    y: 4.82,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 20,
      marginLeft: 23
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "RECEIVED")))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 52,
    y: 23,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "RECEIVED")))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 153,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 143.23,
    y: 153,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 165,
    y: 158,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 173,
      marginLeft: 166
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "REVIEW COMPLETED")))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 195,
    y: 177,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "REVIEW COM...")))), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 242.23,
    y: 4.82,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 242.23,
    y: 4.82,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 257.49,
    y: 8.23,
    width: 73,
    height: 33.18,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 71,
      height: 1,
      paddingTop: 25,
      marginLeft: 258
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "SENT TO LAW FIRM")))), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 294,
    y: 28,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "SENT TO LAW...")))), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 501.23,
    y: 153,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 501.23,
    y: 153,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 523,
    y: 158,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 173,
      marginLeft: 524
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "DRAFT RECEIVED")))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 553,
    y: 177,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "DRAFT RECE...")))), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 670.23,
    y: -0.18,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 670.23,
    y: -0.18,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 684.5,
    y: 4.82,
    width: 75,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 73,
      height: 1,
      paddingTop: 20,
      marginLeft: 686
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "PATENT APP FILED")))), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 722,
    y: 23,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "PATENT APP F...")))), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 830.24,
    y: 153,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#000000",
    stroke: "none",
    pointerEvents: "all",
    transform: "translate(2,3)",
    opacity: 0.25
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 830.24,
    y: 153,
    width: 103.53,
    height: 40,
    rx: 6,
    ry: 6,
    fill: "#f5f5f5",
    stroke: "none",
    pointerEvents: "all"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 852.01,
    y: 158,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 173,
      marginLeft: 853
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "LICENSE OPTION")))), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 882,
    y: 177,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "LICENSE OP...")))), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 73,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 88,
      marginLeft: 92
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "1 Month")))), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 121,
    y: 92,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "1 Month")))), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 214,
    y: 73,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 88,
      marginLeft: 215
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2 Weeks")))), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 244,
    y: 92,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2 Weeks")))), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 387,
    y: 73,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 88,
      marginLeft: 388
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "3 Months")))), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 417,
    y: 92,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "3 Months")))), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 610.23,
    y: 73,
    width: 60,
    height: 30,
    fill: "none",
    stroke: "none",
    pointerEvents: "all"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-0.5 -0.5)"
  }, /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    pointerEvents: "none",
    width: "100%",
    height: "100%",
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility",
    style: {
      overflow: "visible",
      textAlign: "left"
    }
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      display: "flex",
      alignItems: "unsafe center",
      justifyContent: "unsafe center",
      width: 58,
      height: 1,
      paddingTop: 88,
      marginLeft: 611
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-drawio-colors": "color: rgba(0, 0, 0, 1); ",
    style: {
      boxSizing: "border-box",
      fontSize: 0,
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-block",
      fontSize: 12,
      fontFamily: "Helvetica",
      color: "rgb(0, 0, 0)",
      lineHeight: 1.2,
      pointerEvents: "all",
      whiteSpace: "normal",
      overflowWrap: "normal"
    }
  }, "2 Months")))), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 640,
    y: 92,
    fill: "rgba(0, 0, 0, 1)",
    fontFamily: "Helvetica",
    fontSize: "12px",
    textAnchor: "middle"
  }, "2 Months"))))), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", {
    requiredFeatures: "http://www.w3.org/TR/SVG11/feature#Extensibility"
  }), /*#__PURE__*/React.createElement("a", {
    transform: "translate(0,-5)",
    xlinkHref: "https://www.diagrams.net/doc/faq/svg-export-text-problems",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("text", {
    textAnchor: "middle",
    fontSize: "10px",
    x: "50%",
    y: "100%"
  }, "Viewer does not support full SVG 1.1")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDisclosureTimeline);
export default __webpack_public_path__ + "static/media/disclosure_timeline.d9e0b9c280477d596a7186dd1b5cc393.svg";
export { ForwardRef as ReactComponent };